module.exports = __webpack_public_path__ + "static/IMG_7845-424cd0fcb809cbba9b76c076d3feb980.jpg";